module.exports = __webpack_public_path__ + "img/zuluguard.c91e35db.png";